<div class="auth-wrapper d-flex no-block justify-content-center align-items-center"
     [style]="'background-image:url('+ environment.loginbgPath +')'"
>
  <div class="auth-box m-3 m-md-0">
    <div id="loginform" >
      <div class="logo">
        <span class="db"><img [src]="environment.logoPath" style="width: -webkit-fill-available; width: -moz-available;" alt="logo" /></span>
        <br>
        <br>
        <h5 class="font-medium m-b-20">{{ 'tfa.title' | translate}}</h5>
        <h6 class="font-medium m-b-20">{{ 'tfa.dialog' | translate}}</h6>
      </div>
      <!-- Form -->
      <div class="row">
        <div class="col-12">
          <div class="form-horizontal m-t-20">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1"><i class="ti-key"></i></span>
              </div>
              <input type="text" class="form-control" [(ngModel)]="codice" [placeholder]="'tfa.codePlaceholder' | translate" >
            </div>
            <div class="col-sm-12 text-center ">
              <button (click)="resend()" class="btn  btn-sm text-info ">{{'tfa.resend' | translate}}</button>
            </div>
            <br>
            <div class="text-center">
              <div class="col-xs-12 p-b-20">
                <button (click)="verify()" class="btn btn-block btn-lg btn-info">{{ 'tfa.login' | translate}}</button>
              </div>
              <!-- <div *ngIf="error">{{error}}</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
